import { Injectable } from '@angular/core';
import { NavController } from 'ionic-angular';

@Injectable()
export class AppNavProvider {
    private navCtrl: NavController;
    constructor() {}

    public setNavController(navController: NavController): void {
        this.navCtrl = navController;
    }

    public getNavController(): NavController {
        return this.navCtrl;
    }
}



// WEBPACK FOOTER //
// ./src/providers/app_nav.ts